import { SubmissionType } from "../../../generated/graphql";
import { SelectionCard, SelectionCardOption } from "../../Inputs/SelectionCard";
import { FlexRow } from "../__styles__/Layout";
import { Container, ContentSection, HeaderSection } from "../__styles__/Modal";
import { Title } from "../Typography";

type SubmissionTypeSelectionProps = {
  onSelect: (submissionTypeId: string) => void;
  submissionTypes: Array<
    Pick<SubmissionType, "id" | "name" | "category" | "description" | "modules">
  >;
};

export function SelectSubmissionType({
  onSelect,
  submissionTypes,
}: SubmissionTypeSelectionProps) {
  const submissionTypeOptions = submissionTypes.map(
    submissionType =>
      ({
        id: submissionType.id,
        value: submissionType.id,
        title: submissionType.name,
        iconName: "clipboard-check",
      }) satisfies SelectionCardOption,
  );

  return (
    <Container width="narrow">
      <HeaderSection>
        <FlexRow
          css={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Title size="small" type="semiBold">
            Send mail
          </Title>
        </FlexRow>
      </HeaderSection>
      <ContentSection>
        <SelectionCard.Group
          handleSelection={onSelect}
          direction="vertical"
          spacing="compact"
        >
          {submissionTypeOptions.map(submissionType => (
            <SelectionCard.Item
              key={submissionType.id}
              value={submissionType.id}
              borderStyle="ghost"
              size="compact"
            >
              <SelectionCard.CommonContent title={submissionType.title} />
            </SelectionCard.Item>
          ))}
        </SelectionCard.Group>
      </ContentSection>
    </Container>
  );
}
